import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// Vue.$cookies.config(expireTimes[,path[, domain[, secure[, sameSite]]])  // default: expireTimes = 1d, path = '/', domain = '', secure = '', sameSite = 'Lax'

export default Vue.$cookies
